const MAX_DEVICE_PIXEL_RATIO = 2;

export function getDevicePixelRatio(): number {
  if (typeof window === "undefined") return 1;
  return Math.min(window.devicePixelRatio || 1, MAX_DEVICE_PIXEL_RATIO);
}

export function syncCanvasBackingStore({
  canvas,
  logicalWidth,
  logicalHeight,
}: {
  canvas: HTMLCanvasElement;
  logicalWidth: number;
  logicalHeight: number;
}): number {
  const dpr = getDevicePixelRatio();
  const backingWidth = Math.round(logicalWidth * dpr);
  const backingHeight = Math.round(logicalHeight * dpr);
  if (canvas.width !== backingWidth || canvas.height !== backingHeight) {
    canvas.width = backingWidth;
    canvas.height = backingHeight;
  }
  return dpr;
}
